<template>
    <div>
        <div v-show="section === 'offers'" class="offers-page p-6 mx-auto md:w-2/3 lg:w-1/2 xl:w-1/3 2xl:w-1/4">
            <offers
                :custom-offer="customOffer"
                :billing-profile="billingProfile"
                :loading="loading"
                :error="error"
                @continue="previewOrAccept"
            />
        </div>

        <payment-authorization
            v-if="section === 'payment-authorization'"
            :account-id="account.id"
            :consumer-portal-data="data"
            :transactions="paymentAuthorizationTransactions"
            :template="paymentAuthorizationAgreementTemplate"
            @accepted="accept"
            @canceled="previewDeclined"
        />

        <offer-summary v-else-if="section === 'summary'"
            :consumer-portal-data="data"
            :transactions="transactions"
            :settings="$parent.settings"
            :account="account"
            :details="{
                account_id: account.id
            }"
            :electronic-consent-template="electronicConsentTemplate"
            :electronic-consent-declined-template="electronicConsentDeclinedTemplate"
        />
    </div>
</template>

<script>
    import Offers from './CustomOffers/Offers.vue'
    import PaymentAuthorization from '../components/PaymentAuthorization.vue';
    import OfferSummary from '../components/OfferSummary.vue'
    import Moment from 'moment/moment'

    export default {
        components: { OfferSummary, PaymentAuthorization, Offers },

        props: {
            account: Object,
            customOffer: Object,
            billingProfile: Object,
            data: Object,
            obtainPaymentAuthorization: Boolean,
        },

        data() {
            return {
                section: 'offers',

                transactions: null,
                electronicConsentTemplate: null,
                electronicConsentDeclinedTemplate: null,
                paymentAuthorizationTransactions: null,
                paymentAuthorizationAgreementTemplate: null,

                pageForEvents: 'custom-offers-page',

                form: null,
                loading: false,
                error: null,
            }
        },

        methods: {
            previewOrAccept(form) {
                if (
                    this.obtainPaymentAuthorization
                    && this.$parent.settings.feature_payment_authorization_agreement
                ) {
                    return this.preview(form);
                } else {
                    this.form = {...form};

                    return this.accept();
                }
            },

            preview(form) {
                this.form = {...form};

                this.loading = true;

                if (this.form.frequency === 'monthly' && this.paymentDateIsLastDayOfMonth(1)) {
                    this.form.frequency = 'end-of-month';
                }

                this.$http.post(
                    `${this.data.consumerPortalBaseUrl}/api/payments/preview`, this.form
                ).then(({ data }) => {
                    this.paymentAuthorizationAgreementTemplate = data.payment_authorization_agreement_template;
                    this.transactions = this.paymentAuthorizationTransactions = data.transactions;

                    this.loading = false;
                    this.section = 'payment-authorization';
                });
            },

            accept() {
                this.loading = true;

                this.$http.post(
                    `${this.data.consumerPortalBaseUrl}/api/payments`, this.form
                ).then(({ data }) => {
                    this.electronicConsentTemplate = data.electronic_consent_template;
                    this.electronicConsentDeclinedTemplate = data.electronic_consent_declined_template;

                    this.loading = false;
                    this.section = 'summary';
                }, error => {
                    this.loading = false;

                    if (error.hasOwnProperty('body')) {
                        if (error.body.hasOwnProperty('errors') && error.body.errors.hasOwnProperty('zip')) {
                            this.error = error.body.errors.zip[0];
                        } else if (error.body.hasOwnProperty('errors')) {
                            this.error = error.body.errors;
                        } else if (error.body.hasOwnProperty('error')) {
                            this.error = error.body.error;
                        }

                        this.section = 'offers';

                        setTimeout(() => {
                            let offerElement = document.getElementById('email-error');

                            if (offerElement) {
                                window.scrollTo({
                                    top: offerElement.offsetTop - 20,
                                    behavior: 'smooth'
                                });
                            }
                        }, 750);
                    } else {
                        throw error;
                    }
                });
            },

            previewDeclined() {
                this.paymentAuthorizationTransactions = null;
                this.paymentAuthorizationAgreementTemplate = '';

                this.section = 'offers';
            },

            paymentDateIsLastDayOfMonth(dateIdx) {
                return Moment(this.form.payment_dates[dateIdx]).format('DD')
                    === Moment(this.form.payment_dates[dateIdx]).endOf('month').format('DD');
            },
        }
    }
</script>
